/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { EducationLevel, Gender, IdNowStatus, IdTypes, RoleNames } from '../types/utils';
import { PaymentMethod, PaymentMethodID } from './payment-method-model';
import { InvestmentID } from './investment-model';
import { Company } from './company-model';
import { Experience } from './experience-model';
import { CreateWalletInput } from './create-wallet-input';

export type UserID = string;

export class User {
	id: UserID = ''

	address?: string

	addressCity?: string

	addressCountry?: string

	addressZipcode?: string

	birthCity?: string

	birthDate?: Date

	cellphone?: string

	citizenship?: string

	company?: Company | null

	createdAt?: Date

	customerInfoEffectaGmbh?: boolean

	defaultPaymentMethod?: PaymentMethodID

	email: string = ''

	employment?: string

	experience?: Experience | null

	firstName?: string

	gender?: Gender

	highestEducation?: EducationLevel

	idDocumentCountry?: string

	idDocumentExpiryDate?: Date

	idDocumentIssueDate?: Date

	idDocumentIssuingAgency?: string

	idDocumentNumber?: string

	idDocumentType?: IdTypes

	idNowId?: string

	idNowStatus?: IdNowStatus

	idNowTransactionId?: string

	investments?: Array<InvestmentID>

	lastName?: string

	notUSTax?: boolean

	paymentMethods?: Array<PaymentMethod>

	politicallyExposed?: boolean

	politicallyExposedReason?: string

	privacyPolicy?: boolean

	role: RoleNames = RoleNames.USER

	subscribedToProductUpdates?: boolean

	taxNumber?: string

	termsEffectaGmbh?: boolean

	termsFinproAG?: boolean

	updatedAt?: Date

	wallet?: CreateWalletInput

	constructor(obj?: any) {
		if (obj) {
			Object.assign(
				this,
				obj
			);
		}
	}

	isVerificationStarted() : boolean {
		return !!this.idNowStatus;
	}

	isVerified() : boolean {
		return this.idNowStatus === IdNowStatus.SUCCESS;
	}
}